<template>
  <transition name="dialog-fade">
    <div class="custom-dialog" v-if="visible">
      <div class="dialog-mask" @click.stop="handleCancel"></div>
      <transition name="dialog-slide">
        <div class="dialog-container" @click.stop>
          <div class="dialog-header">
            <h3>{{ title }}</h3>
            <i class="el-icon-close" @click.stop="handleCancel"></i>
          </div>
          <div class="dialog-body">
            <slot name="form"></slot>
          </div>
          <div class="dialog-footer">
            <el-button @click.stop="handleCancel">取 消</el-button>
            <el-button :loading="loading" type="primary" @click.stop="handleConfirm">确 定</el-button>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'CustomDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '咨询工单'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleCancel() {
      this.$emit('cancel')
    },
    handleConfirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;

  .dialog-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2001;
  }

  .dialog-container {
    position: relative;
    width: 30%;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    z-index: 2002;
  }

  .dialog-header {
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;

    h3 {
      margin: 0;
      font-size: 18px;
      color: #303133;
    }

    .el-icon-close {
      cursor: pointer;
      color: #909399;
      &:hover {
        color: #409EFF;
      }
    }
  }

  .dialog-body {
    padding: 20px;
  }

  .dialog-footer {
    padding: 10px 20px;
    text-align: right;
    border-top: 1px solid #eee;
  }
}
.dialog-fade-enter-active,
.dialog-fade-leave-active {
  transition: opacity 0.3s ease;
}

.dialog-fade-enter-from,
.dialog-fade-leave-to {
  opacity: 0;
}

/* 滑动动画 */
.dialog-slide-enter-active,
.dialog-slide-leave-active {
  transition: all 0.3s ease;
}

.dialog-slide-enter-from,
.dialog-slide-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>
